import { render, staticRenderFns } from "./WorkflowBulkEdit.vue?vue&type=template&id=4a9e3f37"
import script from "./WorkflowBulkEdit.vue?vue&type=script&lang=js"
export * from "./WorkflowBulkEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports